import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export type Language = 'en' | 'cs' | 'de' | 'fr' | 'it' | 'pl' | 'es' | 'ro' | 'nl';

interface LanguageContextProps {
  language: Language;
  setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextProps>({
  language: 'en',
  setLanguage: () => {},
});

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguageState] = useState<Language>('en');

useEffect(() => {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('lang') as Language | null;
    const supportedLanguages: Language[] = ['en', 'cs', 'de', 'fr', 'it', 'pl', 'es', 'ro', 'nl'];

    if (stored && supportedLanguages.includes(stored)) {
      setLanguageState(stored);
    } else {
      const browserLang = supportedLanguages.find(lang =>
        navigator.language.toLowerCase().startsWith(lang)
      ) || 'en';
      setLanguageState(browserLang);
      localStorage.setItem('lang', browserLang);
    }
  }
}, []);

  const setLanguage = (lang: Language) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('lang', lang);
    }
    setLanguageState(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
